import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTag = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0 252V48C0 21 21 0 48 0h204c13 0 25 5 34 14l212 212c19 19 19 49 0 68L294 498a48 48 0 01-68 0L14 286c-9-9-14-21-14-34zM112 64a48 48 0 100 96 48 48 0 000-96z" })
});
export default SvgTag;
